"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebChatPopUp = void 0;
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var WebChatPopUp = /** @class */ (function (_super) {
    __extends(WebChatPopUp, _super);
    function WebChatPopUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadWebChatScript = function () {
            if (_this.props.policyNumber) {
                var value = (0, commonFunctions_1.getWebChatScriptValueByPolicyNumber)(_this.props.policyNumber);
                var contentGuruDisabled_1 = String(process.env.REACT_APP_CONTENT_GURU_CHAT_DISABLED).toLowerCase() === "true";
                if (value) {
                    var scriptPath = contentGuruDisabled_1 ? "/genesys/genesys-web-chat-script-".concat(value, ".js") : "/web-chat-script-".concat(value, ".js");
                    // Check if the script is already loaded
                    if (!document.querySelector("script[src=\"".concat(scriptPath, "\"]"))) {
                        var script = document.createElement("script");
                        script.src = scriptPath;
                        script.async = true;
                        script.onload = function () {
                            if (typeof window.WebChat === "function") {
                                if (contentGuruDisabled_1) {
                                    window.WebChat("init");
                                }
                                window.WebChat("subscribe", "MessagingService.ready", function () {
                                    window.WebChat("subscribe", "MessagingService.sendingMessage", function () {
                                        _this.pushEventToAdobeDataLayer("botMessageSent");
                                    });
                                });
                            }
                            else {
                                var providerName = contentGuruDisabled_1 ? "Genesys" : "ContentGuru";
                                console.error("".concat(providerName, " is not defined in the local script."));
                            }
                        };
                        document.head.appendChild(script);
                    }
                }
            }
        };
        return _this;
    }
    WebChatPopUp.prototype.componentDidMount = function () {
        this.loadWebChatScript();
    };
    WebChatPopUp.prototype.render = function () {
        // No UI components to render, only loading script
        return null;
    };
    WebChatPopUp.prototype.pushEventToAdobeDataLayer = function (eventName) {
        var key = 'adobeDataLayer';
        window[key] = window[key] || [];
        window[key].push({
            event: eventName
        });
    };
    return WebChatPopUp;
}(React.Component));
exports.WebChatPopUp = WebChatPopUp;
//# sourceMappingURL=WebChatPopUp.js.map